<template>
  <div v-async="loading">
    <div class="row">
      <div class="col-md-6">
        <div>
          <search-bar
            ref="searchBar"
            title="Buscar Grupo"
            @doSearch="doSearch"
            :cols="10"
          />
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end align-items-center">
        <button
          @click="addNewGroup"
          class="btn btn-primary-blue"
          v-if="$can('CENTRAL_CADASTROS_GRUPO_ACESSO_VISUALIZAR_EDITAR')"
        >
          + Adicionar Grupo
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <grupo-acesso-table
          :config="tableConfig"
          @click="selectGroup"
          @setPage="setPage"
          class="mt-4"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SearchBar from "@/components/SearchBar.vue";
import RolesServices from "@/services/portal/RolesService";
import FormRowHeader from "@/components/forms/FormRowHeader.vue";
import GrupoAcessoTable from "./components/GrupoAcessoTable.vue";
export default {
  data() {
    return {
      loading: undefined,
      tableConfig: {
        conteudo: new Array(),
        pagination: undefined,
      },
      filter: {
        size: 10,
        page: 0,
      },
    };
  },
  mounted() {
    this.setBreadcrumbsParam("Grupos de Acesso");
    this.doSearch();
  },
  methods: {
    selectGroup({ id }) {
      this.$router.push({ name: "GruposAcesso", params: { id } });
    },
    addNewGroup() {
      this.$router.push({ name: "AdicionarGrupoAcesso" });
    },
    doSearch(search = this.$refs.searchBar.content, resetPage = false) {
      const { size, page } = this.filter;
      this.loading = RolesServices.getRoles({
        filtro: search,
        size,
        page: resetPage ? 0 : page,
      })
        .then((response) => {
          this.tableConfig.conteudo = response.data.content;
          this.tableConfig.pagination = response.data;
        })
        .catch((error) => this.mxHandleRequestError(error));
    },
    setPage(page) {
      this.filter.page = page;
      this.doSearch();
    },
  },
  components: {
    SearchBar,
    FormRowHeader,
    GrupoAcessoTable,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/style.scss";
@import "@/assets/style/colors.scss";
@import "@/assets/style/breakpoints.scss";
.text {
  @include phablet {
    margin-top: 10px;
  }
}
</style>
